'use client';

import type { ReactElement } from 'react';
import React from 'react';
import { Toaster as HotToaster } from 'react-hot-toast';

const TOAST_DURATION = 3000;

function Toaster(): ReactElement {
  return (
    <HotToaster
      position="bottom-right"
      toastOptions={{ duration: TOAST_DURATION }}
    />
  );
}

export default Toaster;
